export const appHead = {"link":[{"rel":"dns-prefetch","href":"https://static.cloudflareinsights.com"},{"rel":"dns-prefetch","href":"https://bat.bing.com"},{"rel":"dns-prefetch","href":"https://ak.sail-horizon.com"},{"rel":"dns-prefetch","href":"https://www.google-analytics.com"},{"rel":"dns-prefetch","href":"https://www.facebook.com"},{"rel":"dns-prefetch","href":"https://googleads.g.doubleclick.net"},{"rel":"dns-prefetch","href":"https://api.sail-personalize.com"},{"rel":"dns-prefetch","href":"https://stats.g.doubleclick.net"},{"rel":"dns-prefetch","href":"https://www.google.co.uk"},{"rel":"dns-prefetch","href":"https://logs-01.loggly.com"},{"rel":"dns-prefetch","href":"https://in.hotjar.com"},{"rel":"dns-prefetch","href":"https://script.hotjar.com"},{"rel":"dns-prefetch","href":"https://vars.hotjar.com"},{"rel":"dns-prefetch","href":"https://static.hotjar.com"},{"rel":"dns-prefetch","href":"https://img.youtube.com"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"format-detection","content":"telephone=no"},{"name":"format-detection","content":"address=no"},{"name":"google","content":"notranslate"},{"name":"apple-mobile-web-app-status-bar-style","content":"#00747f"},{"name":"theme-color","content":"#00747f"},{"name":"p:domain_verify","content":"05d99242028681e4e4652caad6390b17"},{"name":"google-site-verification","content":"BIqVxPhiE2h1PnuT5ZjjYf8Azke93EIDL_rFhzSz2Mw"},{"name":"application-name","content":"Unbiased"},{"name":"description","content":"Connecting you with the UK’s biggest selection of financial advisers, mortgage brokers, accountants & bookkeepers, we’ve connected millions with the unbiased advice they need."},{"property":"og:image:width","content":"500"},{"property":"og:image:height","content":"500"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"en-GB"},"title":"Find 27,000 IFAs, Financial Advisers, Mortgage Brokers, Accountants & Bookkeepers","titleTemplate":"%s %separator %siteName","templateParams":{"separator":"|"}}

export const appPageTransition = {"name":"fade-transition","mode":"out-in"}

export const appLayoutTransition = {"name":"fade-transition","mode":"out-in"}

export const appKeepalive = true

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = true

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = true

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = true

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false